import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const TidalSuffixInputFieldWrapper = styled.div`
  width: 100%;
  & > .label {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 8px;
    position: relative;
    width: fit-content;
    color: ${(props) => props.theme.colors.text[0]};
    & > span {
      position: absolute;
      right: -10px;
      bottom: 4px;
      color: ${(props) => props.theme.colors.text[3]};
    }
  }
`;

const TidalSuffixInputFieldContainer = styled.div<{
  isFocused: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-gap: 0 8px;
  align-items: center;
  border-radius: 10px;
  border: ${(props) => (props.isFocused ? '2px' : '1px')} solid
    ${(props) =>
      props.isFocused
        ? props.theme.colors.accent
        : props.theme.colors.borderColors[0]};
  background-color: ${(props) => props.theme.colors.secondary};
  padding: 0 16px;
  width: 100%;
  & > input {
    height: 42px;
    background-color: ${(props) => props.theme.colors.secondary};
    outline: none;
  }
  & > .input-suffix {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    justify-content: flex-end;
    color: ${(props) => props.theme.colors.accent};
  }
`;

interface ITidalSuffixInputField {
  label: string;
  placeholder: string;
  suffix: string;
  isRequired?: boolean;
  type?: string;
  name?: string;
  defaultValue?: string;
  value?: string;
  onBlur?: (e: any) => void;
  onChange?: (e: any) => void;
}

const TidalSuffixInputField = ({
  label,
  placeholder,
  isRequired,
  suffix,
  type,
  name,
  value,
  defaultValue,
  onBlur,
  onChange,
}: ITidalSuffixInputField): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);
  const [valueState, setValueState] = useState(defaultValue);

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <TidalSuffixInputFieldWrapper>
      <p className="label">
        {label}
        {isRequired && <span>*</span>}
      </p>
      <TidalSuffixInputFieldContainer isFocused={isFocused}>
        <input
          name={name}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          type={type}
          placeholder={placeholder}
          value={valueState}
          onChange={(e) => onChange && onChange(e)}
        />
        <div className="input-suffix">{suffix}</div>
      </TidalSuffixInputFieldContainer>
    </TidalSuffixInputFieldWrapper>
  );
};

export default TidalSuffixInputField;
